import { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import "./App.css";

import Header from "./Header";
import HomePage from "./Pages/Home/HomePage";
import IntroCompany from "./Pages/About/IntroCompany";
import LocationPage from "./Pages/About/LocationPage";
import SelfPublishingPage from "./Pages/SelfPublishing/SelfPublishingPage";
import SemiPlannedPublishingPage from "./Pages/Semi-PlannedPublishing/SemiPlannedPublishingPage";
import GetStartedPage from "./Pages/GetStarted/GetStartedPage";
import AmazonPage from "./Pages/Amazon/AmazonPage";
import PlannedPublishingPage from "./Pages/PlannedPublishing/PlannedPublishingPage";
import QASelf from "./Pages/QA/QASelf";
import QASemiPlanned from "./Pages/QA/QASemiPlanned";
import QAPlanned from "./Pages/QA/QAPlanned";
import QAAmazon from "./Pages/QA/QAAmazon";
import QuotePage from "./Pages/Quote/QuotePage";
import LoginPage from "./Pages/Login/LoginPage";
import SignupPage from "./Pages/Signup/SignupPage";
import { AuthProvider } from "./Context/AuthContext";
import SnsLoginCallbackPage from "./Pages/SnsLoginCallbackPage/SnsLoginCallbackPage";
import SnsCreatePasswordPage from "./Pages/SnsCreatePasswordPage/SnsCreatePasswordPage";

import DevHeader from "./dev/Header/devHeader";
import CreateEditBook from "./dev/Books/Create new/createEditBook";
import DevBookList from "./dev/Books/Book list/bookList";
import UserManagementPage from "./dev/Authors/UserManagementPage";
// import ServiceList from "./dev/Services/ServiceList";
import ServiceDetail from "./dev/Services/ServiceDetail";
import UserList from "./dev/Users/UserList";
import PermissionsPage from "./dev/Permissions/PermissionsPage";
import PrivacyPopup from "./Pages/Signup/Component/PrivacyPopup";
import ServiceOptionSettings from "./dev/Settings/ServiceOptionSettings";
import CarouselBookSettings from "./dev/Settings/CarouselBookSettings";
import BackToTopButton from "./Components/BackToTopButton/BackToTopButton";
import RequireAdmin from "./Pages/Login/RequireAdmin";
import ProposalManagement from "./dev/Proposals/ProposalManagement";
import PasswordResetRequest from "./Pages/PasswordReset/PasswordResetRequest";
import SetNewPassword from "./Pages/SetPassword/SetNewPassword";
import EmailVerification from "./Pages/EmailVerification/EmailVerification";
import ProfilePage from "./Pages/Profile/ProfilePage/ProfilePage";
import RequireAuth from "./Pages/Login/RequireAuth";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

// Admin Panel Layout
function AdminPages() {
  return (
    <div className="admin-app">
      <DevHeader />
      <main className="admin-content">
        <Routes>
          <Route path="create-new-book" element={<CreateEditBook />} />
          <Route path="edit-book/:id" element={<CreateEditBook />} />
          <Route path="book-list" element={<DevBookList />} />
          <Route path="author-list" element={<UserManagementPage />} />
          <Route path="proposals" element={<ProposalManagement />} />
          <Route path="users" element={<UserList />} />
          <Route path="settings" element={<ServiceOptionSettings />} />
          <Route path="carousel-books" element={<CarouselBookSettings />} />
          <Route path="permissions" element={<PermissionsPage />} />
          <Route path="*" element={<Navigate to="author-list" replace />} />
        </Routes>
      </main>
    </div>
  );
}

// Main Site Layout
const MainLayout = () => {
  const location = useLocation();
  const [showFloatingButton, setShowFloatingButtons] = useState(false);

  const isAuthPage = [
    "/login",
    "/signup",
    "/login/callback",
    "/login/create-password",
    "/login/password-reset-request",
    "/login/set-new-password",
    "/login/verify-email",
  ].includes(location.pathname);
  const isPrivacyPopup = location.pathname === "/privacy-popup";
  const showHeader = !isAuthPage && !isPrivacyPopup;

  const appContainerClass =
    isAuthPage || isPrivacyPopup
      ? "App-container full-screen-layout"
      : "App-container";

  useEffect(() => {
    const toggleFloatingButtons = () => {
      const scrolledDown = window.pageYOffset > 300;
      const isAtBottom =
        window.innerHeight + window.pageYOffset >=
        document.documentElement.scrollHeight - 100;

      if (scrolledDown && !isAtBottom) {
        setShowFloatingButtons(true);
      } else {
        setShowFloatingButtons(false);
      }
    };

    if (showHeader) {
      window.addEventListener("scroll", toggleFloatingButtons);
    }

    return () => {
      window.removeEventListener("scroll", toggleFloatingButtons);
    };
  }, [showHeader]);

  return (
    <div className={appContainerClass}>
      {showHeader && <Header />}
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/About" element={<IntroCompany />} />
        <Route path="/Location" element={<LocationPage />} />
        <Route path="/self-publishing" element={<SelfPublishingPage />} />
        <Route
          path="/semi-planned-publishing"
          element={<SemiPlannedPublishingPage />}
        />
        <Route path="/privacy-popup" element={<PrivacyPopup />} />
        <Route path="/get-started" element={<GetStartedPage />} />
        <Route path="/amazon" element={<AmazonPage />} />
        <Route path="/planned-publishing" element={<PlannedPublishingPage />} />
        <Route path="/qa-self" element={<QASelf />} />
        <Route path="/qa-semi-planned" element={<QASemiPlanned />} />
        <Route path="/qa-planned" element={<QAPlanned />} />
        <Route path="/qa-amazon" element={<QAAmazon />} />
        {/* <Route path="/quote" element={<RequireAuth><QuotePage /></RequireAuth>} /> */}
        <Route path="/quote" element={<QuotePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/login/callback" element={<SnsLoginCallbackPage />} />
        <Route path="/profile" element={<RequireAuth><ProfilePage /></RequireAuth>} />
        <Route
          path="/login/create-password"
          element={<SnsCreatePasswordPage />}
        />
        <Route
          path="/login/password-reset-request"
          element={<PasswordResetRequest />}
        />
        <Route path="/login/set-new-password" element={<SetNewPassword />} />
        <Route path="/login/verify-email" element={<EmailVerification />} />
        <Route
          path="*"
          element={
            <div
              style={{
                padding: "50px",
                textAlign: "center",
                minHeight: "calc(100vh - 200px)",
              }}
            >
              <h2>404 - Page Not Found</h2>
              <p>The page you are looking for does not exist.</p>
            </div>
          }
        />
      </Routes>
      {showFloatingButton && (
        <>
          <BackToTopButton />
          <div
            className="kakao-floating-button"
            onClick={() => window.open("https://pf.kakao.com/_nmwJn", "_blank")}
          >
            <img
              src="./images/kakao-floating-icon.svg"
              alt="카카오톡 채팅하기"
            />
          </div>
        </>
      )}
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route
            path="/admin/*"
            element={
              <RequireAdmin>
                <AdminPages />
              </RequireAdmin>
            }
          />

          <Route path="/*" element={<MainLayout />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
